import React, { useEffect } from "react";

// The dialog frame every asset form uses. Escape and a click on the backdrop
// close it, unless it is saving.
export default function AssetModal({ title, wide, busy, onClose, onSubmit, submitLabel = "Save", submitClass = "am-btn-primary", error, children, footer }) {
  useEffect(() => {
    const onKey = (e) => e.key === "Escape" && !busy && onClose();
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [busy, onClose]);

  return (
    <div className="am-modal-backdrop" onMouseDown={(e) => e.target === e.currentTarget && !busy && onClose()}>
      <div className={`am-modal${wide ? " wide" : ""}`} role="dialog" aria-modal="true" aria-label={title}>
        <div className="am-modal-head">
          <h3>{title}</h3>
          <button type="button" className="am-close" onClick={onClose} disabled={busy} aria-label="Close">✕</button>
        </div>
        <form
          onSubmit={(e) => {
            e.preventDefault();
            if (onSubmit && !busy) onSubmit();
          }}
        >
          <div className="am-modal-body">
            {error && <div className="am-error">{error}</div>}
            {children}
          </div>
          <div className="am-modal-foot">
            {footer || (
              <>
                <button type="button" className="am-btn am-btn-ghost" onClick={onClose} disabled={busy}>Cancel</button>
                {onSubmit && (
                  <button type="submit" className={`am-btn ${submitClass}`} disabled={busy}>
                    {busy ? "Saving…" : submitLabel}
                  </button>
                )}
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export function Field({ label, hint, children }) {
  return (
    <label className="am-field">
      <span>{label}</span>
      {children}
      {hint && <small>{hint}</small>}
    </label>
  );
}
